import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import type { ColumnIdentification, TableSettingsConfig } from '../../data/table-column-config';
import { MatButton } from '@angular/material/button';
import { OverlayModule } from '@angular/cdk/overlay';
import { SettingsOverlayComponent } from '../settings-overlay/settings-overlay.component';
import { MatIcon } from '@angular/material/icon';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';

@Component({
  selector: 'pct-feature-table-material-settings-button',
  imports: [MatButton, MatIcon, OverlayModule, SettingsOverlayComponent, CustomMatSvgIconDirective],
  templateUrl: './settings-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsButtonComponent {
  readonly tableId = input.required<string>();
  readonly columns = input.required<ColumnIdentification[]>();
  readonly displayedColumns = input.required<string[]>();
  readonly config = input.required<TableSettingsConfig>();

  protected readonly overlayOpened = signal(false);

  protected triggerOverlay(): void {
    this.overlayOpened.update(prev => !prev);
  }
}
